export default {
  exampleState: {},
  globalLoader: false,
  userState: { name: "", onboarding_verified_at: null, currency: "&#36;", currentPlan: { slug: "basic" } },
  loginErrorState: { data: {}, error: false },
  registrationErrorState: { data: {}, error: false },
  pendingOrdersState: {},
  dashboardStatisticalDataState: { totalAmountOwed: 0, totalAmountPastDue: 0 },
  customerFilterState: [],
  companyFilterState: [],
  fromDateFilterState: "",
  statusFilterState: "Pending payment",
  toDateFilterState: "",
  customerState: { name: "", email: "" },
  customerOrdersState: [],
  planState: [],
  accountDetailsState: {
    address: null,
    subDomain: "",
    company: null,
    instructions: null,
    emailSignature: null,
    isNewScopesAvailable: false,
    customNetTerms: [],
    multipleEmailAddresses: [],
    settings: {
      periodicUpdates: null,
      sendInvoiceOnPendingOrderCreation: null,
      sendStripePaymentLinkInEmail: null,
      sendShopifyCheckoutPaymentLinkInEmail: null,
      calculateNetPaymentDaysFromFulfillmentDate: null,
      statementForCustomers: {
        isSettingEnabled: false,
        days: 90
      },
      selectedInvoiceTemplate: "primary",
      remainingAllowedOrdersCount: null,
      logoUrl: null
    }
  },
  customNetTermsSpecialAllowances: ["biokanetics"],
  orderLimitExhaustedNotification: 0,
  planConstraintsState: {
    basic: {
      maxEmailVolume: 5
      // 'maxInvoiceVolume' => 'unlimited'
    },
    professional: {
      maxEmailVolume: 20
      //   maxInvoiceVolume: 1000
    },
    smb: {
      maxEmailVolume: 50
      //   maxInvoiceVolume: 2000
    },
    enterprise: {
      //   maxEmailVolume: "unlimited"
    }
  }
};
